<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<div id="attractions" class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/goarailway.jpg" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong>39 km (52 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/goaairport.jpg" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Goa International Airport (GOI)</p>
        <span class="text-muted">Distance From Hotel to airport <strong>17.26 km (30 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Shree Mangueshi Temple.webp" class="card-img-top" alt="Shree Mangueshi Temple">
      <div class="card-body">
        <p class="card-text">Shree Mangueshi Temple</p>
        <span class="text-muted">Distance From Hotel to Shree Mangueshi Temple  <strong>26 km (40 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Shree Shantadurga Temple.webp" class="card-img-top" alt="Shree Shantadurga Temple">
      <div class="card-body">
        <p class="card-text">Shree Shantadurga Temple</p>
        <span class="text-muted">Distance From Hotel to Shree Shantadurga Temple  <strong>34 km (54 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Palolem Beach.webp" class="card-img-top" alt="Palolem Beach">
      <div class="card-body">
        <p class="card-text">Palolem Beach</p>
        <span class="text-muted">Distance From Hotel to Palolem Beach  <strong>74 km (1hr 46 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Deltin Royale.webp" class="card-img-top" alt="Deltin Royale">
      <div class="card-body">
        <p class="card-text">Deltin Royale</p>
        <span class="text-muted">Distance From Hotel to Deltin Royal  <strong>7.1 km (16 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Agonda.webp" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Agonda</p>
        <span class="text-muted">Distance From Hotel to Agonda  <strong>74 km (1hr 44 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/basilica.jpg" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Basilica of Bom Jesus</p>
        <span class="text-muted">Distance From Hotel to Basilica of Bom Jesus <strong>22 min (15.4 km)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/arambol.jpg" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Arambol Beach</p>
        <span class="text-muted">Distance From Hotel to Arambol Beach<strong>58 min (30.2 km)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/reis.jpg" class="card-img-top" alt="Agonda">
      <div class="card-body">
        <p class="card-text">Reis Magos Fort</p>
        <span class="text-muted">Distance From Hotel to Reis Magos Fort <strong>16 min (7.7 km)</strong></span>
      </div>
    </div>
  </div>
</div>




<div class="gallery-container">
  <!-- Dynamic property images carousel in mobile view -->
  <div class="gallery-images-section">
    <h2>Our Gallery</h2>

    <!-- Carousel view for mobile devices -->
    <ngx-slick-carousel
      class="gallery-carousel"
      *ngIf="isMobileView"
      [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <!-- Grid view for larger screens -->
    <div class="gallery-image-grid" *ngIf="!isMobileView">
      <div class="gallery-image-card" *ngFor="let image of property?.imageList">
        <img [src]="image.url" alt="Property Image">
      </div>
    </div>
  </div>
</div>








<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://www.google.com/travel/search?q=bsg%20absolute%20porvorim%20regency%20goa%20hotel&g2lb=4899568%2C4899570%2C4965990%2C4969803%2C10210991%2C72277293%2C72302247%2C72317059%2C72406588%2C72414906%2C72421566%2C72471280%2C72472051%2C72481459%2C72485658%2C72499705%2C72560029%2C72573224%2C72614662%2C72616120%2C72619927%2C72647020%2C72648289%2C72658035%2C72686036%2C72760082%2C72803964%2C72808078%2C72832973%2C72845639&hl=en-IN&gl=in&cs=1&ssta=1&ts=CAEaRwopEicyJTB4M2JiZmMwMGZlMWU0MDlkZDoweDY1YTkxNTNmMTlmZmY4NWQSGhIUCgcI6Q8QARgDEgcI6Q8QARgEGAEyAhAA&qs=CAEyE0Nnb0kzZkRfel9HbnhkUmxFQUU4AkIJCV34_xk_FallQgkJXfj_GT8VqWU&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwj49f3T2L-KAxUAAAAAHQAAAAAQBQ" class="btn btn-primary btn-lg writereview">
      <div style="padding-left: 10px;padding-right: 10px; color: white;">
        Write a Review
      </div>
    </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <!-- Second Column (Carousel for Desktop) -->
<div class="col-md-8 mb-4 d-md-block">
  <div class="card shadow-sm border-0 h-100">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner c-review-carousel" style="display: block;">
        <div
          class="carousel-item"
          data-interval="10000"
          *ngFor="let item of googleReviews; let i = index"
          [ngClass]="{ 'active': i === 0 }"
        >
          <div class="row">
            <div class="col-md-12 d-flex justify-content-center">
              <div class="c-review p-3">
                <div style="text-align: center;">
                  <div>
                    <img
                      src="assets/images/user.png"
                      alt="{{ item.reviewerName }}"
                      class="rounded-circle img-fluid shadow-lg mb-3"
                      style="width: 80px; height: 80px;"
                    />
                  </div>
                  <div>
                    <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                  </div>
                  <div>
                    <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                  </div>
                  <div class="star-ratings text-warning">
                    {{ '★'.repeat(item.rating) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Carousel Controls Positioned Outside -->
    <div class="carousel-controls">
      <a
        class="carousel-control-prev"
        href="#carouselExampleControls"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleControls"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>





  </div>
</div>






  <div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d123009.6778778237!2d73.74291459478502!3d15.535319609546052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bbfc00fe1e409dd%3A0x65a9153f19fff85d!2sKadamba%20Depot%20Rd%2C%20Defence%20Colony%2C%20Porvorim%2C%20Salvador%20du%20Mundu%2C%20Goa%20403501!3m2!1d15.535334899999999!2d73.82531639999999!5e0!3m2!1sen!2sin!4v1735018691197!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
             <div   class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
        <h3>Make Unforgettable Memories</h3>
        <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to us.</p>
        <button class="book-btn" (click)="navigate()">Book Your Stay</button>
        <p class="contact-footer">
          <i class="fa fa-phone"></i> {{property?.mobile}}
        </p>
        <p class="contact-footer">
          <i class="fa fa-envelope"></i> {{property?.email}}
        </p>

      </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE" storage-option="none" language-code="en" max-query-length="-1"   >
  <df-messenger-chat-bubble  id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank" >
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>

